<template>
  <div class="login">
    <!-- <div class="login-banner"></div> -->
    <el-form
      ref="loginForm"
      :model="loginForm"
      :rules="loginRules"
      class="login-form"
    >
      <h3 class="title">江苏检察机关先进典型宣传展示平台</h3>
      <el-form-item prop="userName" v-if="!isWxLogin">
        <el-input
          v-model="loginForm.userName"
          type="text"
          prefix-icon="el-icon-my-user"
          auto-complete="off"
          placeholder="请输入手机号"
          @keyup.enter.native="keyUp"
        >
        </el-input>
      </el-form-item>
      <el-form-item prop="password" class="password" v-if="!isWxLogin">
        <el-input
          show-password
          v-model="loginForm.password"
          type="password"
          prefix-icon="el-icon-my-pwd"
          auto-complete="off"
          placeholder="请输入密码"
          @keyup.enter.native="keyUp"
        >
        </el-input>
      </el-form-item>

      <el-form-item style="width: 100%" v-if="!isWxLogin">
        <el-button
          :loading="loading"
          size="medium"
          type="primary"
          class="login-btn"
          @click.native.prevent="handleLogin"
          v-points="2000"
        >
          <span v-if="!loading">登 录</span>
          <span v-else>登 录 中...</span>
        </el-button>
      </el-form-item>
      <!-- <WxLogin
        id="login_containerw"
        appid="wxfaa075e20cb4a689"
        :scope="'snsapi_login'"
        :redirect_uri="encodeURIComponent('http://10.10.0.152:8080')"
        style="text-align: center"
        v-show="isWxLogin"
      ></WxLogin> -->
      <div id="login_containers" style="margin-top: -40px" v-show="isWxLogin">
        微信二维码
      </div>
    </el-form>
    <!--  底部  -->
    <div class="el-login-footer">
      <span
        >Copyright © 2021 江苏检察机关先进典型宣传展示平台 <br />
        建议使用谷歌、搜狗浏览器，若使用360浏览器，请切换极速模式</span
      >
    </div>
  </div>
</template>

<script>
// import WxLogin from 'vue-wxlogin';
import { isphone } from "@/filters";
import { mapActions } from "vuex";
import { Login, wxLogin } from "@/api/open.js";
export default {
  // components: { WxLogin },
  name: "Login",
  data() {
    return {
      loginForm: {
        userName: "", //15100000000
        password: "",
      },
      loginRules: {
        userName: isphone(),
        password: [
          { required: true, trigger: "blur", message: "密码不能为空" },
          {
            pattern:
              /^(?=.*?[a-z])(?=.*?[A-Z])(?=.*\d)(?=.*[~!@#$%^&*()_+`\-={}:";'<>?,.\/]).{8,16}$/,
            message:
              "请输入长度8-16位，包括数字、大写字母、小写字母、特殊字符的密码",
          },
        ],
      },
      loading: false,
      redirect: undefined,
      keyDown: 0,
      isWxLogin: false,
    };
  },
  watch: {
    $route: {
      handler: function (route) {
        this.redirect = route.query && route.query.redirect;
      },
      immediate: true,
    },
  },
  created() {},
  mounted() {
    console.log(this.$route.query.code);
    if (this.$route.query.code) {
      let parmas = {
        user_id: this.$route.query.id,
        code: this.$route.query.code,
      };
      wxLogin(parmas)
        .then((res) => {
          if (res.code == 200) {
            this.$message.success(res.msg);
            this.$store.dispatch("GetInfo", res.data);
            // this.$store.dispatch("GetInfo", );
            this.$router.push({
              path: "/taggingManage/personal-center",
            });
          } else {
            this.$message.error(res.msg);
            setTimeout(() => {
              window.location.href = "/login";
            }, 1000);
          }
          this.loading = false;
        })
        .catch((error) => {
          this.$message.error("登录失败,请重试");
          this.loading = false;
          setTimeout(() => {
            window.location.href = "/login";
          }, 1000);
        });
    }
  },
  methods: {
    getWx(val) {
      console.log(val);
      let href = window.location.href;
      console.log(href);
      new WxLogin({
        self_redirect: false,
        id: "login_containers", // 需要显示的容器id
        appid: "wxdd82d8b2407c693d", // 公众号appid wx*******
        scope: "snsapi_login", // 网页默认即可
        redirect_uri: encodeURIComponent(`${href}?id=${val}`), // 授权成功后回调的
        state: Math.ceil(Math.random() * 1000), // 可设置为简单的随机数加session用来校验
        style: "black", //  提供"black"、"white"可选。二维码的样式
        // href: "https://static.zcool.cn/passport4.0/css/wxCode.css?v=0.1", // 二维码外部css文件url，需要https
      });
    },
    ...mapActions(["GetInfo"]),
    keyUp() {
      var that = this;
      that.keyDown++;
      if (that.keyDown == 1) {
        that.handleLogin();
      }
      setTimeout(() => {
        that.keyDown = 0;
      }, 1000);
    },
    handleLogin() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          let parmas = {
            phone: this.loginForm.userName,
            password: this.$md5(this.loginForm.password),
          };
          //此处直接调用后台判断账号密码的接口正确返回isWxLogin= true
          Login(parmas)
            .then((res) => {
              console.log(res);
              if (res.code == 200) {
                this.$message.success("账号密码正确");
                //开启扫码
                this.isWxLogin = true;
                this.getWx(res.data.id);
                //
                //获得信息

                // 跳过扫码
                // this.$store.dispatch("GetInfo", res.data);
                // this.$router.push({
                //   path: "/taggingManage/personal-center",
                // });
              }
              this.loading = false;
            })
            .catch((error) => {
              this.$message.success(error);
              this.loading = false;
            });
        }
      });
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss">
@import "./index.scss";
.password {
  position: relative;
  input {
    padding-right: 75px;
  }
}
.append {
  position: absolute;
  right: 0px;
  top: 0;
  cursor: pointer;
  color: #c2c1c1;
}
#login_containers {
  text-align: center;
}
</style>
